import { Component, OnInit,  EventEmitter, Input, Output } from '@angular/core';
import { FormControl, Validators} from '@angular/forms';
import {LegalEntityDetail, PackageDetails} from "../model/lei-model";

@Component({
  selector: 'app-lei-package',
  templateUrl: './lei-package.component.html',
  styleUrls: ['./lei-package.component.scss']
})

export class LeiPackageComponent implements OnInit {

  //phase 2 only
  public servicesForLTResearch = [
    { value: 'LT', display: 'LT' },
    { value: 'LT-HT', display: 'LT-HT' },
  ];

  public productsForLTResearch = [
    { value: 'EQUITY', display: 'EQUITY' },
    { value: 'FICC', display: 'FICC' },
  ];

  public exemptions = [
    { value: 'Require UK FICC Exemption', display: 'Require UK FICC Exemption' },
    { value: 'Do not require UK FICC Exemption', display: 'Do not require UK FICC Exemption' },
  ];

  public productsForLTResearchToolTip = [
    'J.P. Morgan has categorised the following research as FICC Research which can be accessed free of charge:',
    '(i)\tCOMMODITIES RESEARCH',
    '(ii)\tCREDIT RESEARCH',
    '(iii)\tECONOMIC RESEARCH',
    '(iv)\tEMERGING MARKETS RESEARCH',
    '(v)\tFIXED INCOME STRATEGY',
    '(vi)\tFX STRATEGY',
    '(vii)\tSECURITIZED PRODUCTS RESEARCH'
  ];


  @Input() isMifidRebundlingEnabled : boolean;
  @Input() packageDetails: PackageDetails;
  @Input() leiDetail: LegalEntityDetail;
  @Input() index: number;
  @Input() last: number;

  private serviceSelectFormControl : FormControl;
  private productSelectFormControl : FormControl;
  private exemptionSelectFormControl : FormControl;

  @Output() PackageDetailsValid: EventEmitter<boolean> = new EventEmitter();
  @Output() isPaymentShowable: EventEmitter<boolean> = new EventEmitter();
  @Output() addPackageToModel: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit() {

   this.serviceSelectFormControl = new FormControl('', [
      Validators.required]);

    this.productSelectFormControl = new FormControl('', [
      Validators.required]);

    this.exemptionSelectFormControl = new FormControl('', [
      Validators.required]);

  }

  getProductTooltip(){
    return this.productsForLTResearchToolTip.join("\n");
}



  //phase 2 only
  private onServiceSelectChange() {
    this.leiDetail.packagesDetails[0].products = [];
      if(this.leiDetail.domicile !== 'United Kingdom') {
        if (this.leiDetail.packagesDetails[0].service === 'LT') {
          this.leiDetail.packagesDetails[0].products.push('EQUITY', 'FICC')
          this.leiDetail.packagesDetails[0].exemption = 'Do not require UK FICC Exemption';
          this.exemptionSelectFormControl.disable();
        }
      }
      else if(this.leiDetail.packagesDetails[0].service === 'LT-HT'){
        if(this.leiDetail.mifidInScope === 'OPTIN') {
          this.productSelectFormControl.disable();
          this.leiDetail.packagesDetails[0].products.push('FICC')

          this.leiDetail.packagesDetails[0].exemption = 'Do not Want Exemption';
          this.productSelectFormControl.disable();
        }
      }
    }

  private checkProductSelection(product) {
    if(this.leiDetail.domicile !== 'United Kingdom') {
      if (this.isMifidRebundlingEnabled || this.leiDetail.packagesDetails[0].service === 'LT') {
        return true;
      }
      //Phase 2
      else if (product === 'FICC' && this.leiDetail.packagesDetails[0].service === 'LT-HT' && this.leiDetail.mifidInScope === 'OPTIN') {
        return true;
      }
    }
    return false;
  }

  onProductSelectChange() {
    if(this.leiDetail.domicile === 'United Kingdom' && !this.isMifidRebundlingEnabled) {
      if (this.leiDetail.packagesDetails[0].products[0] === 'EQUITY') {
        if (!this.leiDetail.packagesDetails[0].products.includes('FICC'))
          this.leiDetail.packagesDetails[0].products.push('FICC');
        this.leiDetail.packagesDetails[0].service = 'LT';
      }
      else if (this.leiDetail.packagesDetails[0].products.includes('FICC')) {
        if (this.leiDetail.packagesDetails[0].products[0] !== 'EQUITY') {
          this.leiDetail.packagesDetails[0].exemption = 'Require UK FICC Exemption';
          this.leiDetail.packagesDetails[0].service = 'LT';
          this.exemptionSelectFormControl.enable();
        }
      }
      else if (this.leiDetail.packagesDetails[0].products.includes('EQUITY')) {
        this.leiDetail.packagesDetails[0].products.push('FICC')
      }
    }
    this.exemptionSelectFormControl.disable();

    // this.paymentShowable();
    }

  paymentShowable(){
    if(this.leiDetail.domicile === 'United Kingdom' && this.leiDetail.packagesDetails[0].products[0] === 'FICC'
      && this.leiDetail.packagesDetails[0].exemption === 'Require UK FICC Exemption'){
      this.isPaymentShowable.emit(true);
    }
    else{
      this.isPaymentShowable.emit(false);
    }
  }

  isExemptionSelectable(){
    if(this.isMifidRebundlingEnabled){
      if((this.leiDetail.domicile !== 'United Kingdom' && (this.leiDetail.mifidInScope === 'IN' || this.leiDetail.mifidInScope === 'OPTIN'))
        || (this.leiDetail.domicile === 'United Kingdom' && this.leiDetail.mifidInScope === 'IN' && !this.leiDetail.packagesDetails[0].products.includes('EQUITY'))){
        return true;
      }

    }
  }

  private addAnotherPackage(event){
    this.addPackageToModel.emit();
  }

  private checkServicesSelectValidation():boolean {
    return this.leiDetail.packagesDetails[0].service != null;
  }

  private checkProductsSelectValidation():boolean {
    return this.leiDetail.packagesDetails[0].products != null;
  }

  private checkExemptionSelectValidation():boolean {
    return this.leiDetail.packagesDetails[0].products != null && (this.leiDetail.packagesDetails[0].products.includes('FICC') &&
      this.leiDetail.packagesDetails[0].exemption !== '');
  }

  setValidityOfPackage() {
    if(this.serviceSelectFormControl.valid && this.productSelectFormControl.valid && this.exemptionSelectFormControl.valid
    && this.isMifidRebundlingEnabled ? this.checkServicesSelectValidation(): true && this.checkProductsSelectValidation()
      && (this.leiDetail.packagesDetails[0].products.includes('FICC') ? this.checkExemptionSelectValidation(): true ) )

      this.PackageDetailsValid.emit(true);
    else
      this.PackageDetailsValid.emit(false);
  }


}
